// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3gebR","inner":"Form_inner__3tOdx","range":"Form_range__1haTE","name":"Form_name__3M0ul","actions":"Form_actions__1v8gs"};